import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import * as DateHelper from '@/Utility/DateHelper';
import Utilities from '@/Utility/Utilities';

export default class DateBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.date = {
            init: (node: HTMLElement, valueAccessor: () => { date: Date, showDate?: boolean, showTime?: boolean}) => {
                const parameter = valueAccessor();

                if (Utilities.isNullOrUndefined(parameter.showDate))
                    parameter.showDate = true;

                if (Utilities.isNullOrUndefined(parameter.showTime))
                    parameter.showTime = true;

                ko.applyBindingsToNode(node,
                    {
                        text: DateHelper.toString(parameter.date, parameter.showDate, parameter.showTime)
                    });
            }
        };
    }
}